export default function HealthClass() {
    const options = [
      { label: "Excellent Health", value: "PP" },
      { label: "Good Health", value: "P" },
      { label: "Some Health Issues", value: "R" },
    ];
    return options;
  }
  